import Config from 'services/config/local';
import Event from './event.class';

// noinspection JSUnresolvedVariable,Eslint
if (!ENVIRONMENT || ['development', 'test'].indexOf(ENVIRONMENT)) {
    require('./events.json'); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    const data = response.data;

    data.objects = data.objects.map(thing => new Event(thing));

    return data;
}

/**
 * EventsApi class.
 */
export default class EventsApi {
    /**
     * @param {$http} $http - Angular $http service.
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.config = Config.api.events;
    }

    /**
     * Get Events
     * @returns {promise}
     */
    getList() {
        return this.$http.get(this.config.listUrl).then(responseDataExtractor);
    }

}



// WEBPACK FOOTER //
// ./app/services/api/events/events.service.js